<template>
  <div id="app">
    <router-view @token-validated="handleTokenValidated"></router-view>
  </div>

  <LiveChatWidget license="19021209" group="1" visibility="minimized" [customerName]="userName"
    [customerEmail]="userEmail"></LiveChatWidget>
</template>

<script>
import axios from 'axios';
import { BACKEND_URL } from "@/environments";
import { LiveChatWidget } from '@livechat/widget-vue'

export default {
  name: "App",
  components: {
    LiveChatWidget
  },
  methods: {
    handleTokenValidated(token) {
      window.dispatchEvent(new CustomEvent('token-validated', { detail: { token } }));
    },
    handleStorageChange(event) {
      if (event.key === 'generatorAuthToken') {
        window.dispatchEvent(new CustomEvent('token-validated', { detail: { token: event.newValue } }));
      }
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      axios
        .get(`${BACKEND_URL}/generator/validate-token?token=${token}`)
        .then((response) => {
          if (response.data.valid) {
            localStorage.setItem('generatorAuthToken', token);
            const decoded = JSON.parse(atob(token.split('.')[1]));
            if (typeof decoded.extensionUsed === 'boolean') {
              localStorage.setItem(
                'extensionUsed',
                decoded.extensionUsed ? 'true' : 'false'
              );
            }
            this.handleTokenValidated(token);
            window.history.replaceState(null, '', window.location.pathname);
          } else {
            localStorage.removeItem('generatorAuthToken');
            console.error('Token is not valid:', response.data.error);
            window.history.replaceState(null, '', window.location.pathname);
          }
        })
        .catch((err) => {
          localStorage.removeItem('generatorAuthToken');
          console.error('Error verifying token:', err);
          window.history.replaceState(null, '', window.location.pathname);
        });
    }
    const params = new URLSearchParams(window.location.search);
    const utmParams = {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || ""
    };
    if (
      utmParams.utm_source ||
      utmParams.utm_medium ||
      utmParams.utm_campaign ||
      utmParams.utm_term ||
      utmParams.utm_content
    ) {
      localStorage.setItem("utm_params", JSON.stringify(utmParams));
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
};
</script>
